import 'babel-polyfill'
import 'unfetch/polyfill'
import React, { StrictMode } from 'react'
import { render } from 'react-dom'
import Root from './containers/Root'
import boot from 'lib/boot'
import './index.css'

boot()

/**
 * Render the root container.
 */

render(
  <StrictMode>
    <Root />
  </StrictMode>,
  document.getElementById('root')
)
